import React from 'react';
import { Link } from 'react-router-dom';
import { trackCategoryCardClick } from '../../utils/analytics';
import '../Styles/reset.css';
import '../Styles/utils.css';
import '../Styles/layout.css';

function CategoryCard({ category }) {
    const handleClick = () => {
        trackCategoryCardClick(category.name);
    };

    return (
        <Link to={`/category/${category.slug}`} className="category-card" onClick={handleClick}>
            <img src={category.image} alt={`${category.name} category illustration`} loading="lazy" />
            <div className="category-card-content">
                <h3>{category.name}</h3>
                <p>{category.description}</p>
            </div>
        </Link>
    );
}

export default CategoryCard;
